<app-panel
  [expanded]="isOpen"
  [initialWidth]="320"
  [contentWidth]="-1"
  (close)="closePanel()"
>
  <div class="flex w-full flex-col">
    <app-tab [tabs]="tabs" (selectedTabIndex)="selectedTab($event)"></app-tab>
    <ng-container #tabComponentContainer></ng-container>
  </div>
</app-panel>
